import { useState } from "react";

import classes from "./Services.module.css";
import { Stack, Typography } from "@mui/material";
import { serviceCategories, servicesData } from "./serviceData";
import ServiceAccordion from "./ServiceAccordion";
import BookingWidgetSection from "../../Components/BookingWidget/BookingWidgetSection";
import useDocumentMeta from "../../utils/useDocumentMeta";

const Services = () => {
  useDocumentMeta(
    "Treatments | Radiance Aesthetics | Hindley | Wigan",
    "Browse advanced facials, microneedling, chemical peels, skin boosters and vitamin injections at Radiance Aesthetics — a nurse-led clinic in Hindley, Wigan.",
  );

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <section className={classes.servicesColourSections}>
      <Stack
        sx={{
          maxWidth: "1108px",
          margin: "0 auto",
          alignItems: "center",
          padding: { xs: "32px 16px", md: "48px 24px" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "var(--font-body)",
            fontSize: "12px",
            fontWeight: 600,
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            color: "var(--color-accent)",
            textAlign: "center",
            mb: 1.5,
          }}
        >
          What We Offer
        </Typography>
        <Typography
          sx={{
            fontFamily: "var(--font-heading)",
            color: "var(--color-primary)",
            fontWeight: 400,
            textAlign: "center",
            fontSize: { xs: "28px", md: "40px" },
            mb: 1.5,
          }}
          variant="h1"
        >
          Our Treatments
        </Typography>

        <Typography
          sx={{
            color: "var(--color-text-light)",
            textAlign: "center",
            fontSize: "16px",
            mb: 5,
            maxWidth: "600px",
            lineHeight: 1.7,
            fontFamily: "var(--font-body)",
          }}
        >
          Discover our range of professional aesthetic treatments, each
          personalised to your skin's unique needs and goals.
        </Typography>

        <Stack
          className={classes.servicesWrapper}
          gap={4}
          sx={{ width: "100%" }}
        >
          {serviceCategories.map(({ key, title }) => (
            <div key={key} className={classes.serviceCategory}>
              <Typography
                variant="h2"
                sx={{
                  mb: 2,
                  color: "var(--color-primary)",
                  fontWeight: 500,
                  fontSize: { xs: "22px", md: "26px" },
                  fontFamily: "var(--font-heading)",
                  lineHeight: 1.3,
                }}
              >
                {title}
              </Typography>
              {servicesData[key]?.map((service) => (
                <ServiceAccordion
                  key={service.id}
                  service={service}
                  isExpanded={expanded === service.id}
                  onChange={handleChange(service.id)}
                />
              ))}
            </div>
          ))}
        </Stack>

        <BookingWidgetSection source="Treatments - All" />
      </Stack>
    </section>
  );
};

export default Services;
